var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BasePage',[_c('Header',{attrs:{"slot":"header"},slot:"header"}),_c('transition',{attrs:{"slot":"content","mode":"out-in","name":"fade"},slot:"content"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }